import {Condition, FieldCondition, FieldInstruction} from '@ucast/core';
import {MongoQueryParser, allParsingInstructions} from '@ucast/mongo';

export const $regex: FieldInstruction<string | RegExp> = {
    type: 'field',
    validate(instruction, value) {
        if (!(value instanceof RegExp) && typeof value !== 'string') {
            throw new Error(
                `"${instruction.name}" expects value to be a regular expression or a string that represents regular expression`
            );
        }
    },
    parse(instruction, rawValue, context) {
        const regx = new RegExp(rawValue);
        return new FieldCondition(instruction.name, context.field, {
            source: regx.source,
            ignoreCase: true,
        });
    },
};

export const $eqo: FieldInstruction<string> = {
    type: 'field',
};

export const mongoQueryParser = new MongoQueryParser({
    ...allParsingInstructions,
    $regex,
    $eqo,
});

export function addCondition(condition: Condition<unknown> | undefined, c: FieldCondition) {
    if (condition != undefined) {
        const operator = condition.operator;
        if (operator == 'and' || operator == 'or') {
            const value = condition.value as FieldCondition<unknown>[];
            value.push(c);
        } else {
            const andCom = {operator: 'and', value: [condition, c]};
            condition = andCom as unknown as Condition<unknown>;
        }
    } else {
        condition = c;
    }

    return condition;
}

export function withoutNull(record: Record<string, unknown>) {
    return Object.fromEntries(Object.entries(record).filter(([, v]) => v != null));
}
